"use client";
import { chakra, InputProps } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { makeFormInputDefaultProps } from "../forms/src/common/styles";

export function DetailsTableFilterInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
} & Omit<InputProps, "onChange" | "size">) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);

  return (
    <chakra.input
      {...props}
      value={value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        setValue(e.target.value)
      }
      {...makeFormInputDefaultProps("transparent")}
    />
  );
}
